// The app shell's layout classes, in their own module so the regression guard
// (src/dom-tests/appShellViewportHeight.test.tsx) can render the real value
// instead of a copy of it — a copy keeps passing after the shell changes.
//
// The shell is viewport-locked: exactly one height authority (`h-dvh`), nothing
// scrolls at the document level, and every route owns an inner scroller. See
// App.tsx for why `min-h-0` has to be here.
export const APP_SHELL_CLASSNAME =
  "w-dvw h-dvh min-h-0 flex flex-col overflow-hidden [--header-height:calc(--spacing(14))]";
